import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { ALLOWED_IP_FORM, EDITABLE_LIST_FIELDS_NAME } from 'src/constants/FormNames';

import { getMode, getList } from 'src/reducers/common/editableListReducer';
import { REDUCER_NAME, updateIps } from 'src/reducers/clients/allowedIps';

import { setGlobalErrors } from 'src/reducers/global';
import EditableList from './EditableList';
import i18next from 'i18next';

const EditableListFormed = reduxForm({
  form: ALLOWED_IP_FORM,
  onSubmitFail: (errors, dispatch) => dispatch(setGlobalErrors(i18next.t('features.ClientAllowedIpSetting.components.EditableListFormed.please_input_IP_address')))
})(EditableList);

const mapStateToProps = state => ({
  initialValues: { [EDITABLE_LIST_FIELDS_NAME]: getList(REDUCER_NAME, state) },
  mode: getMode(REDUCER_NAME, state),
  listData: getList(REDUCER_NAME, state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(updateIps(data[EDITABLE_LIST_FIELDS_NAME]));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(EditableListFormed);
